import { termsOfUse } from '../typesActions/types';

export const accept = () => {
	return { type: termsOfUse.ACCEPT };
};

export const noAccept = () => {
	return { type: termsOfUse.NO_ACCEPT };
};
